import { action } from 'satcheljs';
import { ErrorMap } from '../schema/ErrorMap';

/**
 * Action which sets the global error with the provided errorSource
 * The corresponding errorHandler will respond to this change
 *
 * @param errorSource The view which is source for this error
 * @param errorTitle error message string to be shown to user
 */
export default action(
    'showError',
    function showError(errorSource: ErrorMap, errorTitle: string = null) {
        return {
            errorSource,
            errorTitle,
        };
    }
);
